<template>
  <div class="myActivity">
    <div class="header ay-header">
      <div class="nav">
        <router-link exact v-for="(item,ind) in Registration" :to="item.router"
                     :class="ind == active?'id-nav-recom nav-on':'id-nav-recom'" @click.native="active =ind" replace>
          {{item.title}}
        </router-link>
        <!-- <router-link to="/myActivity/MyFollow" class="id-nav-recom">
                关注的
              </router-link>
              <router-link to="/myActivity/MyUpload" class="id-nav-recom">
                上传的
              </router-link>
              <router-link to="/myActivity/MyNotice" class="id-nav-recom">
                @我的
              </router-link> -->
      </div>
      <!-- <a href="javascript:void(0);"  class="icon-back" @click="fnBack"></a>-->
      <router-link class="icon-back" to="/mymessage" tag="a"></router-link>
    </div>
    <div class="content ay-content">
      <router-view v-if="userId" :userId="userId" :initUtil="initUtil"></router-view>
    </div>
    <!-- 返回顶部按钮 -->
    <div class="back-top" @click="fn" style="display:none">
      返回顶部
    </div>
    <!--修改-->
    <div class="sing-modal upload-modal large-info-modal modal fade" id="Prompt" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <div class="pl-form">
                <h3 class="Prompt-p">
                  修改成功 </br>
                  正在审核中
                </h3>
                <div class="btn-modal-tw">
                  <a href="javascript:void(0);" class="btn-pl-start" @click="prompt()">确定</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        active: '0',
        Registration: [
          {'title': '参与的', 'id': '0', 'router': '/myparticipate/0'},
          {'title': '关注的', 'id': '1', 'router': '/myfollow'},
          {'title': '上传的', 'id': '2', 'router': '/myupload'},
          {'title': '@我的', 'id': '3', 'router': '/mynotice'}
        ],
        initUtil: {
          bodyEl: document.body,
          topNum: 0,
          stopBodyScroll: function (isFixed) {
            var _this = this;
            if (isFixed) {
              _this.topNum = window.scrollY;
              _this.bodyEl.style.position = 'fixed';
              _this.bodyEl.style.overflow = 'hidden';
              _this.bodyEl.style.top = -_this.topNum + 'px';
            } else {
              _this.bodyEl.style.position = '';
              _this.bodyEl.style.top = '';
              _this.bodyEl.style.overflow = '';
              window.scrollTo(0, _this.topNum) // 回到原先的top;
            }
          }
        },
        userId: ''
      }
    },
    methods: {
      //操作按钮事件
      //返回顶部
      fnBack() {
        this.$router.back(-1)
      },
      fn() {
        $('html,body').stop().animate({scrollTop: '0px'}, 500);
      },
      prompt() {
        location.reload()
      }
    },
    beforeRouteLeave(to, from, next) {
      // 设置下一个路由的 meta
      to.meta.keepAlive = false;
      next();
    },
    created: function () {
      var that = this;
      if (that.IsPC()) {
        window.location.href = API.IsPcName
      }
      //账户

      var urlArr = (window.location.href).split('/');
      var len = urlArr.length;
      var name = urlArr[len - 1].toLowerCase();
      that.userId = that.getCookie('userSeqId');
      if (!that.loginFn()) {
        that.$router.push({name: 'login_SignIn'})
      }

    },
    mounted: function () {
      //操作DOM
      //刷新页面
      var that = this;
      $('.router-link-exact-active').addClass('nav-on').siblings().removeClass('nav-on')
      //文本输入框根据内容自动变高
      $('textarea').unbind('input');
      $('textarea').bind('input', function () {
        handleTextareaHeight(this);
      });

      function handleTextareaHeight(element) {
        var textareaMinHeight = 72;
        element.style.height = textareaMinHeight + 'px';
        if (element.scrollHeight > textareaMinHeight) {
          element.style.height = element.scrollHeight + 'px';
        }
      }

      var dataName = {
        title: "央视喊你上电视",  //分享标题
        desc: '央视热门栏目面向广大网友征集原创作品啦！要上电视？那就来吧！一个舞台不一样的精彩。',//metas[1].content,//分享简介(内容)
        imgAddress: "http://img.itv.cctvpic.com/ishow/2018/08/17/9777171c5917ffa6a2b31a5f65aed241.jpg",//分享图片地址
        Retain: '',//保留
        url:  API.UrlName  //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
      };
      that.weixinShare(dataName);
      // that.$http.get(API.GetShareInfo, {params: {module: 'home'}})
      //   .then(function (res) {
      //     if (res.code == 0) {
      //       var title = '',
      //         desc = '';
      //       if (res.data.share_title) {
      //         title = res.data.share_title
      //       } else {
      //         title = '央视喊你上电视'
      //       }
      //       if (res.data.share_contents) {
      //         desc = res.data.share_contents
      //       } else {
      //         desc = '央视网上电视征集 我要上电视 爱西柚 播客 拍客 中央电视台 央视 ishow.CCTV.com 新闻 体育 奥运 综艺 财经 科教 CCTV-1 CCTV新闻 CCTV体育 春晚 星光大道 开学第一课 央视晚会 诗词大会 央视栏目 央视征集活动';
      //       }
      //       var dataName = {
      //         title: title,  //分享标题
      //         desc: that.removeTAG(desc, 110),//metas[1].content,//分享简介(内容)
      //         imgAddress: res.data.share_pic || 'http://ishow.cctv.com/images/poster-img.jpg',//分享图片地址
      //         Retain: '',//保留
      //         url: API.UrlName //点击分享结果跳转的地址('' 默认情况为分享页面当前地址)
      //       };
      //       that.weixinShare(dataName)
      //     }
      //   })
    }

  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/myActivity.vue